import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button
} from '@mui/material';
import { styled } from '@mui/system';
import { Link } from 'react-router-dom';
import { formatter } from '#component/shipment/helper';

const StyledLink = styled(Link)(() => ({
  color: '#212121',
  textDecoration: 'none',
  borderBottom: '1px #212121 solid',
  paddingBottom: 1,
  '&:hover': {
    borderBottom: 'none'
  }
}));

const StyledDialogTitle = styled(DialogTitle)(() => ({
  padding: '16px 24px 0'
}));

const StyledDialogContent = styled(DialogContent)(() => ({
  paddingTop: 0,
  paddingBottom: 0
}));

/**
 * Renders dialog with all shipments and appliances the device is used.
 * @returns {React.FC}
 */
const OccupiedDeviceDialog = props => {
  const {
    setOpenDialog,
    dataDialog: device
  } = props;

  const { shipments, appliances } = device;

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleDialogClick = event => {
    event.stopPropagation();
  };

  const handleDialogMouseDown = event => {
    event.stopPropagation();
  };

  return (
    <Dialog
      open={Boolean(device)}
      onClose={handleClose}
      onClick={handleDialogClick}
      onMouseDown={handleDialogMouseDown}
    >
      <StyledDialogTitle>
        {device.title || device.uid}
      </StyledDialogTitle>
      <StyledDialogContent>
        {shipments?.length && (
          <Typography variant="body1" component="p">
            Active in shipment
            { shipments.length > 1 ? 's' : '' }
            :&nbsp;
            { shipments.map((s, i) => (
              <React.Fragment key={`shipment${s?.uid}`}>
                <StyledLink
                  to={`/shipment/${s.id}`}
                >
                  {s.label ?? formatter(s?.uid)}
                </StyledLink>
                {i + 1 !== shipments.length ? ', ' : ''}
              </React.Fragment>
            ))}
          </Typography>
        )}
        {appliances?.length && (
          <Typography variant="body1" component="p">
            Active in application
            { appliances.length > 1 ? 's' : '' }
            :&nbsp;
            { appliances.map((s, i) => (
              <React.Fragment key={`appliance${s?.uid}`}>
                <StyledLink
                  to={`/warehouse/appliance-overview/${s.id}`}
                >
                  {s.label}
                </StyledLink>
                {i + 1 !== appliances.length ? ', ' : ''}
              </React.Fragment>
            ))}
          </Typography>
        )}
      </StyledDialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default OccupiedDeviceDialog;
